// hooks/useGetTicketsOuverts.js
import { useEffect, useState, useCallback } from "react";
import { getTicketsOuverts } from "../lib/ticket.js";
import { getClientTicketsOuverts } from "../lib/ticket.js";
import { useAuth } from "../context/AuthContext.js";

/**
 * Charge les tickets ouverts du client courant (lu depuis `localStorage.id_entreprise`) et expose `{ tickets, loading, error, refetch }`.
 *
 * @returns {{ tickets: Array, loading: boolean, error: string|null, refetch: Function }}
 */
export function useGetClientTicketsOuverts() {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { isConnected } = useAuth();

  const fetchTickets = useCallback(async (idClient) => {
    if (!idClient) idClient = localStorage.getItem('client_id');
    try {
      setLoading(true);
      setError(null);
      const data = await getClientTicketsOuverts(idClient);
      if (data && data.length > 0) {
        setTickets(data);
      } else {
        setTickets([]); // vide proprement
        setError("Aucun ticket ouvert trouvé");
      }
    } catch (err) {
      setError(`Erreur lors de la récupération des tickets ouvert du client: ${err.message}`);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (isConnected) fetchTickets();
  }, [fetchTickets, isConnected]);

  return { tickets, loading, error, refetch: fetchTickets };
}
